import { defineMessages } from 'react-intl'

const scope = 'procurify.platform.globalSearch.GlobalSearchWorkflows'

export default defineMessages({
  heading: {
    id: `${scope}.heading`,
    defaultMessage: 'Workflows',
  },
  listAriaLabel: {
    id: `${scope}.listAriaLabel`,
    defaultMessage: 'Workflows',
  },
  startGuidedIntakeTitle: {
    id: `${scope}.startGuidedIntakeTitle`,
    defaultMessage: 'Start a new order request with Guided Intake',
  },
  startGuidedIntakeDescription: {
    id: `${scope}.startGuidedIntakeDescription`,
    defaultMessage:
      'Describe what you need and get a structured, policy-compliant request.',
  },
  aiBadge: {
    id: `${scope}.aiBadge`,
    defaultMessage: 'AI',
  },
  betaBadge: {
    id: `${scope}.betaBadge`,
    defaultMessage: 'Beta',
  },
})
